import styled  from 'styled-components';
import PropTypes from 'prop-types';

const ClaroLoadBtn = styled.button`
&& {
  ${props =>
    (props
      ? `
      ${props ? 
        `
        color: ${props.color === undefined ? '#ffffff' : props.color};
        text-align: center;
        border: ${props.border === undefined ? 'none' : props.border};
        border-color: ${props.borderColor === undefined ? '#ffffff' : props.borderColor};
        width: ${props.width === undefined ? '11.466666666666667VW' : props.width};
        height: ${props.height === undefined ? '11.466666666666667VW' : props.height};
        background-color: ${props.backgroundColor === undefined ? '#000' : props.backgroundColor} ;
        border-radius: ${props.borderRadiusClaro === undefined ? '50em' : props.borderRadiusClaro} ;
        line-height: ${props.lineHeight === undefined ? '11VW' : props.lineHeight} ;
        margin: ${props.margin === undefined ? 'opx' : props.margin} ;
        font-size: ${props.fontSize === undefined ? '16px' : props.fontSize};
        font-weight: 'bold';
        font-family: 'Amx-Bold';
        padding: ${props.padding === undefined ? '6px' : props.padding};
        white-space : ${props.white_space === undefined ? 'normal': props.white_space};
        word-wrap: ${props.word_wrap === undefined ? 'break-word': props.word_wrap};
        line-height: ${props.lineHeightClaro === undefined ? '11VW' : props.lineHeightClaro};
        :focus {outline:0;}
        background-image: ${props.isContainerTelcel ? `url(${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}ClaroPayLoadingBlanco2.gif)` :  "url(https://logosuat.claropay.com/ClaroPayLoading2.gif)"};
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
        ${props.disabled ?
          `
            ${props.isContainerTelcel ? "background-color:#d0d0d0" : "background-color:#e6e6e6"};
            opacity:1;
          `
          :
          ''};
        `
        :
        ''};
      `
      : '')
    };
    }`;

ClaroLoadBtn.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  hoverColor: PropTypes.string,
  hoverBackground: PropTypes.string
}

ClaroLoadBtn.defaultProps = {
  height:'50px',
  borderRadius:'5px',
  width:'100%',
};

export default ClaroLoadBtn;